// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Components
import { TxAgencyLogo } from 'texkit-ui';
import Card from 'texkit/dist/components/Cards/Card';
import SquareLockIcon from '../../../../assets/square-lock-02.png';

// Styles
import './agency-card.scss';

const AgencyCard = ({
  agency,
  moreInfoText,
  bodyHeading,
  numLicenses,
  hasLogo = true,
  isLocked = false,
  lockedRequirement,
  showChevron = false,
  variant = 'default',
  className = '',
  ...props
}) => {
  const { t } = useTranslation('tpwd');
  const { t: t_tdlr } = useTranslation('tdlr');
  const isLinkServiceSelectVariant = variant === 'link-service-select';
  const agencyForLogo =
    agency.name === t('AgencyName', { lng: 'es' })
      ? { name: t('AgencyName', { lng: 'en' }) }
      : agency.name === t_tdlr('AgencyName', { lng: 'es' })
      ? { name: t_tdlr('AgencyName', { lng: 'en' }) }
      : agency;

  if (isLinkServiceSelectVariant) {
    return (
      <Card
        {...props}
        className={`agency-card agency-card--link-service-select${
          isLocked ? ' agency-card--locked' : ''
        }${showChevron ? ' agency-card--with-chevron' : ''}${
          className ? ` ${className}` : ''
        }`}
      >
        <>
          <div className="agency-card__header">
            {hasLogo && <TxAgencyLogo agency={agencyForLogo} />}
            <div className="agency-card-text">
              <h3 className="agency-card-title">{agency.name}</h3>
            </div>
            {showChevron && (
              <span className="agency-card__chevron" aria-hidden="true" />
            )}
          </div>
          {isLocked && lockedRequirement && (
            <div className="agency-card__locked-section">
              <div className="agency-card__locked-inner">
                <span className="agency-card__locked-requirement">
                  {lockedRequirement}
                </span>
                <img
                  src={SquareLockIcon}
                  alt=""
                  aria-hidden="true"
                  className="agency-card__locked-icon"
                />
              </div>
            </div>
          )}
          {moreInfoText && (
            <div
              className={`agency-card__body-section${
                isLocked ? ' agency-card__body-section--locked' : ''
              }`}
            >
              {bodyHeading && (
                <h4 className="agency-card__body-heading">{bodyHeading}</h4>
              )}
              <div className="agency-card__body-content">{moreInfoText}</div>
            </div>
          )}
        </>
      </Card>
    );
  }

  return (
    <Card
      {...props}
      className={`agency-card${isLocked ? ' agency-card--locked' : ''}${
        className ? ` ${className}` : ''
      }`}
    >
      <>
        <div className="agency-card__main">
          {hasLogo && <TxAgencyLogo agency={agencyForLogo} />}
          <div className="agency-card-text">
            <h3 className="agency-card-title">{agency.name}</h3>
            {moreInfoText && (
              <p className="agency-card-copy">
                {parseInt(numLicenses, 10) > 1 ? numLicenses + ' ' : ''}
                {moreInfoText}
              </p>
            )}
          </div>
        </div>
      </>
    </Card>
  );
};

AgencyCard.propTypes = {
  moreInfoText: PropTypes.node,
  bodyHeading: PropTypes.node,
  numLicenses: PropTypes.string,
  hasLogo: PropTypes.bool,
  isLocked: PropTypes.bool,
  lockedRequirement: PropTypes.node,
  showChevron: PropTypes.bool,
  variant: PropTypes.string,
  className: PropTypes.string,
  agency: PropTypes.object.isRequired,
};

export default AgencyCard;